
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useModels() {
  const { data: masterData, refetch: refetchMaster } = useQuery({
    queryKey: ["modeldb_master"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("modeldb_master")
        .select("model_name, model_id, maker_id, activated, market, ranking")
        .order("model_name");
      if (error) throw error;
      return data || [];
    },
  });

  const { data: adData } = useQuery({
    queryKey: ["modeldb_ad"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("modeldb_ad")
        .select("model_name, model_id, maker_id, market, ranking")
        .order("model_name");
      if (error) throw error;
      return data || [];
    },
  });

  const { data: atpData } = useQuery({
    queryKey: ["modeldb_atp"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("modeldb_atp")
        .select("model_name, model_id, maker_id, market, ranking")
        .order("model_name");
      if (error) throw error;
      return data || [];
    },
  });

  return { masterData, adData, atpData, refetchMaster };
}
